module.exports = __webpack_public_path__ + "535c9cf586a6e6d239b44d91e1670b7e.svg";